export enum EnumGrid {
  Movimento = 0,
  ItemMovimento = 1,
  ItemSafra = 2,
  NotasFiscais = 3
}